import { useRef } from 'react';
import type { OibInstrumentSummary } from '../../oib/types';
import type { OibReferenceWarning } from '../../oib/contractCheck';

interface OibLoaderProps {
  readonly instrument: OibInstrumentSummary | undefined;
  readonly loadErrors: readonly string[];
  readonly warnings: readonly OibReferenceWarning[];
  readonly onLoadFile: (text: string) => void;
  readonly onClear: () => void;
}

export function OibLoader(props: OibLoaderProps): JSX.Element {
  const inputRef = useRef<HTMLInputElement>(null);

  function handleFile(fileList: FileList | null): void {
    const file = fileList?.[0];
    if (!file) return;
    file.text().then(props.onLoadFile).catch(() => props.onLoadFile('{}'));
  }

  return (
    <div className="oib-panel">
      <p>
        Optional: eine <code>oib.instrument/0.1</code>-Definition laden, um Rollen, Zustaende, Bedienelemente und
        Szenen gegen die aktuelle Sequenz zu pruefen. OIB wird dabei ausschliesslich read-only gelesen - siehe{' '}
        <code>OIB_INTEGRATION_CONTRACT.md</code>.
      </p>
      <input
        ref={inputRef}
        type="file"
        accept="application/json,.json"
        onChange={(event) => handleFile(event.target.files)}
        aria-label="OIB-Instrumentdefinition laden"
      />
      {props.instrument && (
        <button type="button" onClick={props.onClear}>
          Instrument entfernen
        </button>
      )}

      {props.instrument && (
        <div className="oib-summary">
          <p>
            Geladen: <strong>{props.instrument.name}</strong> ({props.instrument.id}), {props.instrument.roles.length}{' '}
            Rollen, {props.instrument.state.length} Zustaende, {props.instrument.controls.length} Bedienelemente,{' '}
            {props.instrument.scenes.length} Szenen.
          </p>
        </div>
      )}

      {props.loadErrors.length > 0 && (
        <div className="warning-list">
          <h4>Ladehinweise</h4>
          <ul>
            {props.loadErrors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      )}

      {props.warnings.length > 0 && (
        <div className="warning-list">
          <h4>Referenzwarnungen ({props.warnings.length})</h4>
          <ul>
            {props.warnings.map((warning, index) => (
              <li key={index}>
                <code>{warning.path}</code> — {warning.message}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
